<template>
    <b-modal ref="pop-error" centered cancel-disabled>
        <template #modal-header>
            <h4 class="text-yellow">{{ $t("member.download_receipt_error_modal_title") }}</h4>
            <span class="error-icon">
            <i class="fas fa-exclamation-triangle"></i>
            </span>
        </template>
        <template #default>
            <p>{{ $t("member.download_receipt_error_modal_content") }}</p>
        </template>
        <template #modal-footer>
            <b-button block size="md" class="btn-yellow text-yellow shadow" @click="hideModal"> OK </b-button>
        </template>
    </b-modal>
</template>

<script>

export default {
  name: "PopDownloadFailModal",
  data() {
    return {
    };
  },
  methods: {
    showModal() {
      this.$refs["pop-error"].show();
    },
    hideModal() {
      this.$refs["pop-error"].hide();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-content {
  border-radius: 0.5rem;
  .error-icon {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #28a745;
    width: 45px;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 1.25rem;
    i {
      color: #fff;
    }
  }
}

::v-deep .modal-header {
  position: relative;
  background-color: #FFED61;
  border-bottom: none !important;
  border-radius: 0.5rem 0.5rem 0 0;
}

::v-deep .modal-body {
  padding-top: 2rem;
}

::v-deep .modal-footer {
  border-top: none !important;
}

.btn-yellow {
  background-color: #FFED61;
  border: none;
}

.text-yellow {
  color: #70631d;
  font-weight: 500;
}
</style>
